// Builds a BreadcrumbList JSON-LD payload from the current path.
// Hooks into <BreadcrumbSchema /> mounted in App so every route gets one
// without touching individual pages.
//
// Backend contract — none. This is pure derived data; the path segments
// are the breadcrumb labels (humanised). When/if a CMS exposes a richer
// page-title-per-route lookup, swap labelForSegment() to read from there.

import { ROUTES } from './routeRegistry';

const SITE_URL = 'https://technumopus.com';

// Prefer the title from the route registry; otherwise prettify the slug.
const labelForPath = (path) => {
  const known = ROUTES.find((r) => r.path === path);
  if (known) return known.title;
  const tail = path.split('/').filter(Boolean).pop() || 'Home';
  return tail
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
};

// Build cumulative crumbs: ['/'] -> ['/', '/blog'] -> ['/', '/blog', '/blog/foo']
const cumulativeSegments = (path) => {
  if (!path || path === '/') return ['/'];
  const parts = path.split('/').filter(Boolean);
  const out = ['/'];
  let cur = '';
  parts.forEach((seg) => {
    cur += `/${seg}`;
    out.push(cur);
  });
  return out;
};

export const buildBreadcrumbSchema = (path) => {
  if (!path) return null;
  const segments = cumulativeSegments(path);
  // Don't emit BreadcrumbList on the home page itself — Google's guidance says
  // it adds no value and can trigger rich-result warnings.
  if (segments.length <= 1) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: segments.map((seg, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: seg === '/' ? 'Home' : labelForPath(seg),
      item: `${SITE_URL}${seg === '/' ? '' : seg}`,
    })),
  };
};
